import { WarningLarge, SuccessLarge } from '@yme/assets/icons';
import { COOKIE_ORDER_NUMBER_KEY } from '@yme/common/constants';
import { COOKIE_CART_ID_KEY, PAYMENT_LINK_PROVIDER } from '@yme/common/redux/cart/constants';
import { colorAccentAlert100, colorAccentSuccess200 } from '@yme/tokens/colors';
export const ICON_MAP = {
    0: WarningLarge,
    1: SuccessLarge,
};
export const COLOR_MAP = {
    0: colorAccentAlert100,
    1: colorAccentSuccess200,
};
export var ModalState;
(function (ModalState) {
    ModalState[ModalState["INITIAL"] = 0] = "INITIAL";
    ModalState[ModalState["SUCCESS"] = 1] = "SUCCESS";
})(ModalState || (ModalState = {}));
export const COOKIE_KEYS = [
    COOKIE_CART_ID_KEY,
    COOKIE_ORDER_NUMBER_KEY,
    PAYMENT_LINK_PROVIDER,
];
